/**
 * Created by abbeymart on 2017-03-06.
 */
import type { RouteRecordRaw } from 'vue-router';

export const auditRoutes: Array<RouteRecordRaw> = [
  {
    path: '/audit',
    name: 'audit',
    redirect: '/audit/list',
    component: () => import('pages/central/audit/McAudit.vue'),
    meta: {
      title: 'Audits Logging Service',
      requiresAuth: true,
    },
    children: [
      {
        path: 'list',
        name: 'auditList',
        component: () => import('pages/central/audit/AuditList.vue'),
        meta: {
          title: 'Audits List',
          requiresAuth: true,
        },
      },
      {
        path: 'list/pa',
        name: 'auditListPA',
        component: () => import('pages/central/audit/AuditListPA.vue'),
        meta: {
          title: 'Audits List (Policy Automation)',
          requiresAuth: true,
        },
      },
      {
        path: 'list/ship',
        name: 'auditListShip',
        component: () => import('pages/central/audit/AuditListShip.vue'),
        meta: {
          title: 'Audits List (Shipping Services)',
          requiresAuth: true,
        },
      },
      {
        path: 'list/pay',
        name: 'auditListPay',
        component: () => import('pages/central/audit/AuditListPay.vue'),
        meta: {
          title: 'Audits List (Payment Services)',
          requiresAuth: true,
        },
      },
      {
        path: 'list/project',
        name: 'auditListProject',
        component: () => import('pages/central/audit/AuditListProject.vue'),
        meta: {
          title: 'Audits List (Project Management)',
          requiresAuth: true,
        },
      },
      {
        path: 'list/trade',
        name: 'auditListTrade',
        component: () => import('pages/central/audit/AuditListTrade.vue'),
        meta: {
          title: 'Audits List (Marketplace Trading)',
          requiresAuth: true,
        },
      },
      {
        path: 'list/info',
        name: 'auditListInfo',
        component: () => import('pages/central/audit/AuditListInfo.vue'),
        meta: {
          title: 'Audits List (Information Marketplace)',
          requiresAuth: true,
        },
      },
      {
        path: 'list/support',
        name: 'auditListSupport',
        component: () => import('pages/central/audit/AuditListSupport.vue'),
        meta: {
          title: 'Audits List (Support Services)',
          requiresAuth: true,
        },
      },
      {
        path: 'detail/:itemId?',
        name: 'auditDetail',
        component: () => import('pages/central/audit/AuditDetail.vue'),
        meta: {
          title: 'Audit Detail',
          requiresAuth: true,
        },
      },
      {
        path: 'new',
        name: 'auditNew',
        component: () => import('pages/central/audit/AuditNew.vue'),
        meta: {
          title: 'New Audit',
          requiresAuth: true,
        },
      },
    ],
  },
];
